/*
  attribution-ref.js — 施策枠「経由の売上」をShopify実注文で測るための目印付与 ＋ GA4ファネル
  計測実装タスク 2026-08 / T1（_ref）＋ T4（枠別ファネル）

  仕組み:
    1. data-ref-block="<枠名>" を持つ要素の中で商品リンクがクリックされたら
       sessionStorage に {ref, handle, ts} を記録する
    2. カート投入直前（クリック/submitのキャプチャ段階＝テーマのhandlerより先）に
       form[action*="/cart/add"] へ hidden input properties[_ref] を差し込む
       - 枠の中から直接カート投入（カードのクイック追加）＝その枠名をそのまま付与
       - 商品ページからのカート投入＝記録した handle と今の商品 handle が一致する時だけ付与
    3. 先頭がアンダースコアの line item property は顧客画面に表示されない（Shopify仕様）

  GA4ファネル（T4・2026-08-17）: 上の記録を使い、枠経由の行動を dataLayer へ送る
    ref_view_item   {ref, handle}          … 枠経由で商品ページを開いた（人数=枠経由の商品閲覧）
    ref_add_to_cart {ref, handle}          … 枠経由の商品をカートに入れた（theme の product:added 成功時）
    ref_purchase    {ref, order_id, value} … 枠経由商品を含む注文の完了（Shopifyカスタムピクセル側で送信。
                                            _docs/pixels/ref_purchase_pixel.js。サンクスページはテーマ外のため）
    → GA4 探索で「枠(ref) × 人数」を並べれば 閲覧→カート→購入 のファネルになる。
      売上金額の正本は Shopify 注文の _ref（attribution_ref.py）。GA4側は人数の把握用

  集計: 07_月次分析/_scripts/attribution_ref.py（Shopify注文の line_items[].properties を集計）
        07_月次分析/_scripts/fetch_ga4_measurement_events.py（ref_* イベント）
  注意: 計測が失敗しても購入導線を止めないこと（全てtry/catchで握りつぶす）
*/
(function () {
  var KEY = 'aniclo_ref';
  var TTL_MS = 6 * 60 * 60 * 1000; // 6時間で失効（同一セッション内の直近クリックのみ有効）

  function save(rec) {
    try { sessionStorage.setItem(KEY, JSON.stringify(rec)); } catch (e) {}
  }
  function read() {
    try {
      var r = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (!r || !r.ts || (Date.now() - r.ts) > TTL_MS) return null;
      return r;
    } catch (e) { return null; }
  }
  function handleOf(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return m ? m[1] : ''; }
  }
  function push(obj) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(obj);
    } catch (e) {}
  }

  // 1) 枠内の商品リンククリックを記録
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var a = t.closest('a[href*="/products/"]');
      if (!a) return;
      var block = a.closest('[data-ref-block]');
      if (!block) return;
      save({
        ref: block.getAttribute('data-ref-block'),
        handle: handleOf(a.getAttribute('href')),
        ts: Date.now()
      });
    } catch (err) {}
  });

  // 2) カート投入フォームに目印を差し込む
  function setRef(form, ref) {
    if (!form || !ref) return;
    var input = form.querySelector('input[name="properties[_ref]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_ref]';
      form.appendChild(input);
    }
    input.value = ref;
  }

  // フォームに付与すべき枠名を決める（枠内直接投入 or 枠経由の商品ページ）
  function refForForm(form) {
    if (!form) return '';
    var block = form.closest('[data-ref-block]');
    if (block) return block.getAttribute('data-ref-block') || '';
    var rec = read();
    if (!rec || !rec.ref || !rec.handle) return '';
    var current = handleOf(window.location.pathname);
    if (!current || current !== rec.handle) return '';
    return rec.ref;
  }

  function stamp(el) {
    try {
      if (!el || !el.closest) return;
      var form = el.closest('form[action*="/cart/add"]');
      if (!form) return;
      var ref = refForForm(form);
      if (ref) setRef(form, ref);
    } catch (err) {}
  }

  // キャプチャ段階で走らせる（テーマの BuyButton がフォームを serialize する前に差し込む）
  document.addEventListener('click', function (e) { stamp(e.target); }, true);
  document.addEventListener('submit', function (e) { stamp(e.target); }, true);

  // 3) GA4ファネル: 枠経由の商品ページ閲覧
  try {
    var current = handleOf(window.location.pathname);
    if (current) {
      var rec = read();
      if (rec && rec.ref && rec.handle === current) {
        push({ event: 'ref_view_item', ref: rec.ref, handle: current });
      }
    }
  } catch (err) {}

  // 4) GA4ファネル: 枠経由の商品をカートに入れた（theme.js が成功時に product:added を発火）
  document.addEventListener('product:added', function (e) {
    try {
      var d = e && e.detail;
      if (!d || d.productAdded === false) return;
      var form = d.button && d.button.closest ? d.button.closest('form[action*="/cart/add"]') : null;
      if (!form && e.target && e.target.closest) form = e.target.closest('form[action*="/cart/add"]');
      var ref = refForForm(form);
      if (!ref) return;
      var handleInput = form ? form.getAttribute('data-product-handle') : '';
      push({ event: 'ref_add_to_cart', ref: ref, handle: handleInput || handleOf(window.location.pathname) || '' });
    } catch (err) {}
  }, true);

})();
